<template>
  <svg viewBox="0 0 8 8" class="dot">
    <circle cx="4" cy="4" r="4" class="outer" />
    <circle
      cx="4"
      cy="4"
      r="2"
      class="center"
      :class="selected && 'selected'"
    />
  </svg>
</template>
      
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "HistoryDot",
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
      
<style lang="scss" scoped>
.dot {
  width: 8px;
  height: 8px;
  .outer {
    fill: $qvo-color-branding-500;
  }
  .center {
    fill: white;
    &.selected {
      fill: $qvo-color-branding-500;
    }
  }
}
</style>